<template>
  <div class="modal-mask" @click="close">
    <div class="modal-container" @click.stop>
      <v-card>
        <v-card-title>
          Transfer NFT with ID: {{item._id}} ({{item.type}})
        </v-card-title>

        <v-divider/>

        <v-card-text>
          Transfer to:
          <v-text-field solo outlined v-model="sendTo">

          </v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red" text @click="close">
            Cancel
          </v-btn>

          <v-btn color="green" text @click="transferButtonClicked(item, table)">
            Transfer
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import NftOperations from "./NftOperations";

export default {
  props: ['item', 'table'],
  mixins: [NftOperations],
  mounted() {
  },
  data() {
    return {
      sendTo: ""
    };
  },
  created: function() {
  },
  methods: {
    transferButtonClicked(item, table) {
      this.transferNft(item, this.sendTo, table);
    },
    close: function () {
      this.$emit('close');
    }
  }
};
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
}

.modal-container {
  width: 500px;
  margin: 40px auto 0;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
</style>